/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { object, string } from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
    OrderDetailHeader: {
        paddingTop: '18px',
        paddingLeft: '10px',
        paddingRight: '10px',
        marginBottom: '69px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '10px',
        },
        '& .black': {
            fontWeight: '700',
            color: '#2e2c2c !important',
            '& span': {
                fontSize: '20px !important',
                color: '#8e8e8e !important',
            },
        },
        '& h1, h1.black > span': {
            fontWeight: '500 !important',
            fontFamily: 'BebasNeue',
            fontSize: '40px !important',
        },
        '& :nth-child(2)': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
        '& .sm-hide': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
        '& .md-hide': {
            [theme.breakpoints.down('sm')]: {
                lineHeight: '40px',
                display: 'block !important',
            },
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
    },
});

class DesktopOrderHeader extends React.PureComponent {
    render() {
        const sourceId = this.props?.orderNumber?.indexOf('W') >= 0 ? '' : this.props?.orderDetails?.orders[0]?.items[0]?.sourceId || 'W0100';

        return (
            <Grid container className={this.props.classes.OrderDetailHeader}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <h1 className="black sm-hide">Order: <span>{`${sourceId}${this.props.orderNumber}`}</span></h1>
                    <h1 className="black md-hide">Order Number: <span>{`${sourceId}${this.props.orderNumber}`}</span></h1>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} align="right">
                    <Link to="/track-order" className="black">
                        Track a different Order
                    </Link>
                </Grid>
            </Grid>
        );
    }
}

DesktopOrderHeader.propTypes = {
    classes: object.isRequired,
    orderDetails: object.isRequired,
    orderNumber: string.isRequired,
};

export default withStyles(styles)(DesktopOrderHeader);
